import React, { Component } from "react";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { Typography, Grid } from "@material-ui/core";
import QRCode from "qrcode.react";
import Numberformat from "../../atoms/Numberformat";
import "react-toastify/dist/ReactToastify.css";

const styles = theme => ({
  refinput: {
    fontSize: 20,
    width: "100%",
    maxWidth: "100%",
    marginBotton: theme.spacing(1)
  },
  qrcode: {
    width: "100%",
    height: "auto"
  }
});

class PaymentInfoETH extends Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   direction: null
    // };

    // This binding is necessary to make `this` work in the callback
    this.copy2clipboard = this.copy2clipboard.bind(this);
  }
  copy2clipboard(e) {
    this.refinput.focus();
    this.refinput.select();
    document.execCommand("copy");
    toast(({ closeToast }) => <div>URL copied to clipboard.</div>);
  }
  render() {
    const { classes } = this.props;
    const { currency, toWalletAddress } = this.props.order;
    const { sum, token } = this.props.order.display;
    return (
      <div>
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <Typography gutterBottom>
              Send <Numberformat value={sum} digits={6} />
              &nbsp;{currency} and get <Numberformat value={token} digits={6} />
              &nbsp;CRWD&nbsp;Token to your Wallet
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <QRCode value={toWalletAddress} size={128} />
          </Grid>
          <Grid item xs={12} sm={8}>
            <input
              ref={input => {
                this.refinput = input;
              }}
              defaultValue={toWalletAddress}
              className={classes.refinput}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

PaymentInfoETH.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(PaymentInfoETH);
